// Function name -> page, in sidebar order. Function names don't always match the route
// (e.g. 'attacheddocuments') and some have no page at all ('stampcreating', 'selectcompany').
const FUNCTION_ROUTES = [
  ['scandocument', '/scandocument'],
  ['attacheddocuments', '/attached-documents'],
  ['protocolbook', '/protocolbook'],
  ['archive', '/archive'],
  ['awaitingdocs', '/awaitingDocs'],
  ['stampcollection', '/stampCollection'],
  ['config', '/config'],
  ['admin-dashboard', '/admin-dashboard'],
  ['admin-panel', '/admin-panel'],
]

// First page the user can open, independent of the order the API returns functions in.
// Undefined when none of the functions has a page.
export const getLandingRoute = (functions) => {
  const names = new Set(functions?.map((fun) => fun.name))

  return FUNCTION_ROUTES.find(([name]) => names.has(name))?.[1]
}
